import React, { useState } from 'react';

const RegistrationPage = ({ seminar, onUpdateGuest }) => {
    const [formData, setFormData] = useState({
        email: '',
        lastName: '',
        firstName: '',
        jobFunction: ''
    });
    const [view, setView] = useState('form'); // 'form' or 'confirmation'
    const [confirmation, setConfirmation] = useState({ title: '', message: '' });
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        const action = e.nativeEvent.submitter.value;

        if (action === 'confirm') {
            if (!formData.lastName || !formData.firstName || !formData.jobFunction || !formData.email) {
                setError('Veuillez remplir tous les champs obligatoires.');
                return;
            }
            onUpdateGuest(seminar.id, formData.email, 'inscrit', {
                nom: formData.lastName,
                prenom: formData.firstName,
                fonction: formData.jobFunction
            });
            setConfirmation({
                title: 'Merci !',
                message: 'Votre inscription a bien été prise en compte. Nous avons hâte de vous voir !'
            });
            setView('confirmation');
        } else if (action === 'decline') {
            if (!formData.email) {
                setError('Veuillez entrer votre email pour décliner l\'invitation.');
                return;
            }
            onUpdateGuest(seminar.id, formData.email, 'refus', {});
            setConfirmation({
                title: 'Réponse enregistrée',
                message: 'Nous avons bien noté que vous ne serez pas présent(e). Merci de nous avoir prévenus.'
            });
            setView('confirmation');
        }
    };

    if (!seminar) {
        return <div className="text-center p-8">Séminaire non trouvé.</div>;
    }

    const seminarDate = seminar.isMultiDay 
        ? `Du ${new Date(seminar.startDate + 'T00:00:00').toLocaleDateString('fr-FR')} au ${new Date(seminar.endDate + 'T00:00:00').toLocaleDateString('fr-FR')}`
        : new Date(seminar.startDate + 'T00:00:00').toLocaleDateString('fr-FR');

    return (
        <div className="bg-gray-50 flex items-center justify-center min-h-screen">
            <div className="w-full max-w-md mx-auto p-4">
                {view === 'form' && (
                    <div id="registration-form-card" className="bg-white rounded-xl shadow-lg overflow-hidden">
                        <div className="px-8 py-10">
                            <div className="text-center mb-8">
                                <h1 className="text-2xl font-bold text-gray-800">{seminar.name}</h1>
                                <div className="mt-4 text-gray-600 space-y-2">
                                    <div className="flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                                        </svg>
                                        <span id="seminar-date" className="ml-2 font-medium">{seminarDate}</span>
                                    </div>
                                    <div className="flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                        </svg>
                                        <span id="seminar-location" className="ml-2 font-medium">{seminar.location}</span>
                                    </div>
                                </div>
                                <p className="text-gray-500 mt-4">Confirmez votre présence en remplissant les champs ci-dessous.</p>
                            </div>
                            
                            <form id="registration-form" onSubmit={handleSubmit} className="px-8 pb-10">
                                <div className="space-y-6">
                                    <div>
                                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Adresse e-mail*</label>
                                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-[#F2507B] focus:border-[#F2507B]" />
                                    </div>
                                    <div>
                                        <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">Nom*</label>
                                        <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-[#F2507B] focus:border-[#F2507B]" />
                                    </div>
                                    <div>
                                        <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">Prénom*</label>
                                        <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-[#F2507B] focus:border-[#F2507B]" />
                                    </div>
                                    <div>
                                        <label htmlFor="jobFunction" className="block text-sm font-medium text-gray-700">Fonction*</label>
                                        <input type="text" id="jobFunction" name="jobFunction" value={formData.jobFunction} onChange={handleChange} className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-[#F2507B] focus:border-[#F2507B]" />
                                    </div>
                                </div>
                                {error && <div className="mt-4 text-center text-sm text-red-600">{error}</div>}
                                <div className="mt-8 space-y-4">
                                    <button type="submit" name="action" value="confirm" className="w-full text-white font-bold py-3 px-4 rounded-lg transition-colors text-lg bg-[#22D6B5] hover:bg-opacity-90">
                                        Je serai présent(e)
                                    </button>
                                    <button type="submit" name="action" value="decline" className="w-full text-gray-700 font-bold py-3 px-4 rounded-lg transition-colors text-lg bg-gray-200 hover:bg-gray-300">
                                        Je ne serai pas présent(e)
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
                {view === 'confirmation' && (
                    <div id="confirmation-card" className="bg-white rounded-xl shadow-lg p-10 text-center">
                        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
                            <svg className="h-10 w-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                        </div>
                        <h2 id="confirmation-title" className="text-2xl font-bold text-gray-800">{confirmation.title}</h2>
                        <p id="confirmation-message" className="text-gray-600 mt-2">{confirmation.message}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RegistrationPage;